import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  container: {
    marginBottom: '1.25rem',
    padding: '10px 14px',
    backgroundColor: '#fff',
    border: '1px solid #e8e8e8',
    borderRadius: '10px',
    display: 'flex',
    gap: '10px',
    alignItems: 'center',
    flexWrap: 'wrap',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)'
  },
  searchContainer: {
    flex: 1,
    minWidth: '200px',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#f8f9fc',
    borderRadius: '8px',
    border: '1px solid #e8e8e8',
    padding: '0 10px',
    transition: 'all 0.15s ease',
    '&:focus-within': {
      borderColor: '#4c4cff',
      backgroundColor: '#fff',
      boxShadow: '0 0 0 3px rgba(76, 76, 255, 0.08)'
    }
  },
  searchIcon: {
    color: '#9e9e9e',
    flexShrink: 0
  },
  searchInput: {
    flex: 1,
    padding: '8px 6px',
    border: 'none',
    background: 'transparent',
    fontSize: '0.8125rem',
    color: '#1a1a1a',
    outline: 'none',
    '&::placeholder': { color: '#bdbdbd' }
  },
  clearButton: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: '2px',
    display: 'flex',
    alignItems: 'center',
    color: '#9e9e9e',
    borderRadius: '4px',
    transition: 'all 0.15s',
    '&:hover': { color: '#1a1a1a', backgroundColor: '#f0f0f0' }
  },
  selectWrapper: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#f8f9fc',
    borderRadius: '8px',
    border: '1px solid #e8e8e8',
    padding: '0 10px',
    transition: 'all 0.15s ease',
    '&:focus-within': {
      borderColor: '#4c4cff',
      boxShadow: '0 0 0 3px rgba(76, 76, 255, 0.08)'
    }
  },
  selectIcon: {
    color: '#9e9e9e',
    flexShrink: 0,
    marginRight: '4px'
  },
  select: {
    padding: '8px 4px',
    border: 'none',
    background: 'transparent',
    fontSize: '0.8125rem',
    color: '#1a1a1a',
    cursor: 'pointer',
    outline: 'none',
    appearance: 'none'
  },
  sortContainer: {
    display: 'flex',
    gap: '6px',
    alignItems: 'center'
  },
  sortButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '34px',
    height: '34px',
    border: '1px solid #e8e8e8',
    borderRadius: '8px',
    backgroundColor: '#f8f9fc',
    cursor: 'pointer',
    color: '#616161',
    transition: 'all 0.15s',
    '&:hover': {
      backgroundColor: '#eef1f8',
      borderColor: '#c0c0c0'
    }
  },
  count: {
    display: 'flex',
    alignItems: 'center',
    gap: '5px',
    marginLeft: 'auto',
    fontSize: '0.8125rem',
    fontWeight: 600,
    color: '#1a1a1a',
    whiteSpace: 'nowrap',
    padding: '0.25rem 0.75rem',
    backgroundColor: '#f8f9fc',
    borderRadius: '999px'
  },
  countIcon: {
    color: '#9e9e9e'
  },
  countMuted: {
    fontWeight: 400,
    color: '#9e9e9e'
  }
});

export default useStyles;
